export const CURRENT_USER_ATTRIBUTES = {
  REVERT_TO_CLASSIC_FEEDBACK_MODAL: 'revertToClassicFeedbackModal',
  HAS_SEEN_CUSTOM_ONBOARDING: 'hasSeenOnboardingCustom',
  DISMISSED_ONBOARDING_WITH_MAYBE_LATER_TIMESTAMP: 'dismissedOnboardingCustomWithMaybeLaterTimestamp',
  HAS_INTERACTED_WITH_EMAIL_TEMPLATE_EDITOR: 'hasInteractedWithEmailTemplateEditor',
  HAS_DISMISSED_OUTLOOK_PREVIEW_BANNER: 'dismissedOutlookPreviewBanner',
  HAS_SEEN_ELEMENT_HIDDEN_ON_BOTH_ALERT: 'EmailEditors:HasSeenElementHiddenOnBothAlert',
  SHOW_HIDDEN_ELEMENTS: 'EmailEditors:ShowHiddenElements',
  HAS_DISMISSED_AI_DYNAMIC_TEXT_FEATURE_ANNOUNCE: 'EmailEditors:HasDismissedAIDynamicTextFeatureAnnounce'
};
export const CURRENT_USER_ATTRIBUTES_AS_ARRAY = Object.keys(CURRENT_USER_ATTRIBUTES).map(key => CURRENT_USER_ATTRIBUTES[key]);